<button [ngbTooltip]="'Roll ' + get_Description()" (click)="roll()">
    <app-diceIcons_D20></app-diceIcons_D20>
</button>